// Thin API wrapper for the merchant AI Agent settings page.
// `window.axios` is the authenticated instance set up in entrypoints/dashboard.js.
const http = () => window.axios;

const base = accountId => `/api/v1/accounts/${accountId}/ai_config`;

export const fetchAiConfig = async accountId => {
  const { data } = await http().get(base(accountId));
  return data;
};

export const updateAiConfig = async (accountId, payload) => {
  const { data } = await http().patch(base(accountId), payload);
  return data;
};

const agentInboxAutoReplyPath = (accountId, inboxId) =>
  `/api/v1/accounts/${accountId}/inboxes/${inboxId}/agent_auto_reply`;

export const fetchAgentInboxAutoReply = async (accountId, inboxId) => {
  const { data } = await http().get(agentInboxAutoReplyPath(accountId, inboxId));
  return data;
};

export const updateAgentInboxAutoReply = async (accountId, inboxId, enabled) => {
  const { data } = await http().patch(agentInboxAutoReplyPath(accountId, inboxId), {
    enabled,
  });
  return data;
};

// AI Agent (bot) token usage: summary + per-feature + trend.
export const fetchAgentBotUsage = async ({ accountId, from, to, granularity = 'day' }) => {
  const { data } = await http().get(
    `/api/v1/accounts/${accountId}/agent_bot_usage`,
    { params: { from, to, granularity } }
  );
  return data;
};

// Translation token usage: summary + per-user + trend (reuses translations#usage).
export const fetchTranslationUsage = async ({
  accountId,
  from,
  to,
  userIds = [],
  granularity = 'day',
}) => {
  const { data } = await http().get(
    `/api/v1/accounts/${accountId}/translations/usage`,
    { params: { from, to, user_ids: userIds, granularity } }
  );
  return data;
};
